module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "profile_modal_user",
      "role": "dialog",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [(_vm.getLoading) ? _c('div', {
    staticClass: "row"
  }, [_c('vue-spinner')], 1) : _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('form', {
    attrs: {
      "action": "#",
      "role": "form",
      "enctype": "multipart/form-data"
    }
  }, [_c('div', {
    staticClass: "portlet light avatar-box"
  }, [_c('div', {
    staticClass: "portlet-title tabbable-line"
  }, [_c('div', {
    staticClass: "caption caption-md"
  }, [_c('i', {
    staticClass: "icon-globe theme-font hide"
  }), _vm._v(" "), _c('span', {
    staticClass: "caption-subject bold uppercase"
  }, [_vm._v(_vm._s(_vm.user.fullName))])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "fileinput fileinput-new",
    attrs: {
      "data-provides": "fileinput"
    }
  }, [_c('div', {
    staticClass: "fileinput-new thumbnail"
  }, [_c('avatar', {
    attrs: {
      "username": (_vm.user.fullName != null) ? _vm.user.fullName : 'C M',
      "src": (_vm.user.avatar == null) ? undefined : _vm.user.avatar,
      "size": 140,
      "rounded": true,
      "color": "#d09f23",
      "backgroundColor": "#eef1f5"
    }
  })], 1)]), _vm._v(" "), _c('a', {
    staticClass: "btn green",
    on: {
      "click": _vm.toggleShow
    }
  }, [_vm._v("Upload Image")]), _vm._v(" "), _c('vue-image-crop-upload', {
    attrs: {
      "field": "img",
      "noRotate": false,
      "width": 300,
      "height": 300,
      "lang-type": "en",
      "img-format": "png"
    },
    on: {
      "crop-success": _vm.cropSuccess
    },
    model: {
      value: (_vm.show),
      callback: function($$v) {
        _vm.show = $$v
      },
      expression: "show"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn default",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updateAvatarBase(null)
      }
    }
  }, [_vm._v("Remove")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('div', {
    staticClass: "portlet light"
  }, [_c('div', {
    staticClass: "portlet-title tabbable-line"
  }, [_vm._m(1), _vm._v(" "), _c('ul', {
    staticClass: "nav nav-tabs"
  }, [_vm._m(2), _vm._v(" "), (false) ? _c('li', {}, [_c('a', {
    attrs: {
      "href": "#tab_1_3_user",
      "data-toggle": "tab",
      "aria-expanded": "false"
    }
  }, [_vm._v("Change Password")])]) : _vm._e(), _vm._v(" "), _vm._m(3)])]), _vm._v(" "), _c('div', {
    staticClass: "portlet-body"
  }, [_c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "tab-pane active",
    attrs: {
      "id": "tab_1_1_user"
    }
  }, [_c('form', {
    attrs: {
      "role": "form",
      "data-vv-scope": "profile-form-modal",
      "action": "#"
    }
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('profile-form-modal.Full Name')
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Full Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.fullName),
      expression: "user.fullName"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "",
      "name": "Full Name"
    },
    domProps: {
      "value": (_vm.user.fullName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "fullName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('profile-form-modal.Full Name')),
      expression: "errors.has('profile-form-modal.Full Name')"
    }],
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.first('profile-form-modal.Full Name')))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Email Address")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.email),
      expression: "user.email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "",
      "disabled": _vm.currentUser.access < 5
    },
    domProps: {
      "value": (_vm.user.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "email", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('profile-form-modal.Job Title')
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Job Title")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.jobTitle),
      expression: "user.jobTitle"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "",
      "name": "Job Title"
    },
    domProps: {
      "value": (_vm.user.jobTitle)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "jobTitle", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('profile-form-modal.Job Title')),
      expression: "errors.has('profile-form-modal.Job Title')"
    }],
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.first('profile-form-modal.Job Title')))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('profile-form-modal.Primary Phone')
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Primary Phone")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.primaryPhone),
      expression: "user.primaryPhone"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "",
      "name": "Primary Phone"
    },
    domProps: {
      "value": (_vm.user.primaryPhone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "primaryPhone", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('profile-form-modal.Primary Phone')),
      expression: "errors.has('profile-form-modal.Primary Phone')"
    }],
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.first('profile-form-modal.Primary Phone')))])]), _vm._v(" "), _c('div', {
    staticClass: "margiv-top-10"
  }, [_c('button', {
    staticClass: "btn green mt-ladda-btn ladda-button updateInfoAction_user",
    attrs: {
      "data-style": "expand-left"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updateUserInfo.apply(null, arguments)
      }
    }
  }, [_c('span', {
    staticClass: "ladda-label"
  }, [_vm._v("Save Changes")])]), _vm._v(" "), _c('button', {
    staticClass: "btn default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-hidden": "true"
    }
  }, [_vm._v(" Cancel\n                        ")])])])]), _vm._v(" "), (false) ? _c('div', {
    staticClass: "tab-pane",
    attrs: {
      "id": "tab_1_3_user"
    }
  }, [_c('form', {
    attrs: {
      "action": "#",
      "data-vv-scope": "password-form"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.changePassword.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('password-form.current password')
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Current Password")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.currentPassword),
      expression: "user.currentPassword"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    class: {
      'input': true
    },
    attrs: {
      "type": "password",
      "name": "current password"
    },
    domProps: {
      "value": (_vm.user.currentPassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "currentPassword", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('password-form.current password')),
      expression: "errors.has('password-form.current password')"
    }],
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.first('password-form.current password')))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('password-form.new password')
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("New Password")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.newPassword),
      expression: "user.newPassword"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        min: 4,
        max: 12,
        regex: '^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])[0-9A-Za-z!@#$%]{4,12}$'
      }),
      expression: "{required:true, min:4, max:12, regex: '^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])[0-9A-Za-z!@#$%]{4,12}$' }"
    }],
    staticClass: "form-control",
    class: {
      'input': true
    },
    attrs: {
      "type": "password",
      "id": "newPass_user",
      "name": "new password"
    },
    domProps: {
      "value": (_vm.user.newPassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "newPassword", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('password-form.new password')),
      expression: "errors.has('password-form.new password')"
    }],
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.first('password-form.new password')))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('password-form.confirm new password')
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Confirm New Password")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.confirmNewPassword),
      expression: "user.confirmNewPassword"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        is: _vm.user.newPassword
      }),
      expression: "{required: true, is: user.newPassword}"
    }],
    ref: "new password",
    staticClass: "form-control",
    class: {
      'input': true
    },
    attrs: {
      "type": "password",
      "name": "confirm new password"
    },
    domProps: {
      "value": (_vm.user.confirmNewPassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "confirmNewPassword", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('password-form.confirm new password')),
      expression: "errors.has('password-form.confirm new password')"
    }],
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.first('password-form.confirm new password')))])]), _vm._v(" "), _vm._m(4)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "tab-pane",
    attrs: {
      "id": "tab_1_4_user"
    }
  }, [_c('form', {
    attrs: {
      "action": "#"
    }
  }, [_c('table', {
    staticClass: "table table-light table-hover"
  }, [_c('tbody', [(false) ? _c('tr', [_vm._m(5), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "mt-radio-inline"
  }, [_c('label', {
    staticClass: "mt-radio"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.access),
      expression: "user.access"
    }],
    attrs: {
      "type": "radio",
      "value": "1",
      "name": "userradio-1"
    },
    domProps: {
      "checked": _vm.user.access === 1,
      "checked": _vm._q(_vm.user.access, "1")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.user, "access", "1")
      }
    }
  }), _vm._v(" Yes\n                                "), _c('span')]), _vm._v(" "), _c('label', {
    staticClass: "mt-radio"
  }, [_c('input', {
    staticClass: "userradio-no",
    attrs: {
      "type": "radio",
      "value": "0",
      "name": "userradio-1",
      "disabled": "disabled"
    },
    domProps: {
      "checked": _vm.user.access !== 1
    }
  }), _vm._v(" No\n                                "), _c('span')])])])]) : _vm._e(), _vm._v(" "), _c('tr', [_vm._m(6), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "mt-radio-inline"
  }, [_c('label', {
    staticClass: "mt-radio"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.access),
      expression: "user.access"
    }],
    attrs: {
      "type": "radio",
      "value": "2",
      "name": "userradio-2"
    },
    domProps: {
      "checked": _vm.user.access === 2,
      "checked": _vm._q(_vm.user.access, "2")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.user, "access", "2")
      }
    }
  }), _vm._v(" Yes\n                                "), _c('span')]), _vm._v(" "), _c('label', {
    staticClass: "mt-radio"
  }, [_c('input', {
    staticClass: "userradio-no",
    attrs: {
      "type": "radio",
      "value": "0",
      "name": "userradio-2",
      "disabled": "disabled"
    },
    domProps: {
      "checked": _vm.user.access !== 2
    }
  }), _vm._v(" No\n                                "), _c('span')])])])]), _vm._v(" "), _c('tr', [_vm._m(7), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "mt-radio-inline"
  }, [_c('label', {
    staticClass: "mt-radio"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.access),
      expression: "user.access"
    }],
    attrs: {
      "type": "radio",
      "value": "3",
      "name": "userradio-3"
    },
    domProps: {
      "checked": _vm.user.access === 3,
      "checked": _vm._q(_vm.user.access, "3")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.user, "access", "3")
      }
    }
  }), _vm._v(" Yes\n                                "), _c('span')]), _vm._v(" "), _c('label', {
    staticClass: "mt-radio"
  }, [_c('input', {
    staticClass: "userradio-no",
    attrs: {
      "type": "radio",
      "value": "0",
      "name": "userradio-3",
      "disabled": "disabled"
    },
    domProps: {
      "checked": _vm.user.access !== 3
    }
  }), _vm._v(" No\n                                "), _c('span')])])])]), _vm._v(" "), _c('tr', [_vm._m(8), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "mt-radio-inline"
  }, [_c('label', {
    staticClass: "mt-radio"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.access),
      expression: "user.access"
    }],
    attrs: {
      "type": "radio",
      "value": "4",
      "name": "userradio-4"
    },
    domProps: {
      "checked": _vm.user.access === 4,
      "checked": _vm._q(_vm.user.access, "4")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.user, "access", "4")
      }
    }
  }), _vm._v(" Yes\n                                "), _c('span')]), _vm._v(" "), _c('label', {
    staticClass: "mt-radio"
  }, [_c('input', {
    staticClass: "userradio-no",
    attrs: {
      "type": "radio",
      "value": "0",
      "name": "userradio-4",
      "disabled": "disabled"
    },
    domProps: {
      "checked": _vm.user.access !== 4
    }
  }), _vm._v(" No\n                                "), _c('span')])])])]), _vm._v(" "), _c('tr', [_vm._m(9), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "mt-radio-inline"
  }, [_c('label', {
    staticClass: "mt-radio"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.access),
      expression: "user.access"
    }],
    attrs: {
      "type": "radio",
      "value": "5",
      "name": "userradio-5"
    },
    domProps: {
      "checked": _vm.user.access === 5,
      "checked": _vm._q(_vm.user.access, "5")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.user, "access", "5")
      }
    }
  }), _vm._v(" Yes\n                                "), _c('span')]), _vm._v(" "), _c('label', {
    staticClass: "mt-radio"
  }, [_c('input', {
    staticClass: "userradio-no",
    attrs: {
      "type": "radio",
      "value": "0",
      "name": "userradio-5",
      "disabled": "disabled"
    },
    domProps: {
      "checked": _vm.user.access !== 5
    }
  }), _vm._v(" No\n                                "), _c('span')])])])]), _vm._v(" "), (_vm.currentUser.access > 5) ? _c('tr', [_vm._m(10), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "mt-radio-inline"
  }, [_c('label', {
    staticClass: "mt-radio"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.access),
      expression: "user.access"
    }],
    attrs: {
      "type": "radio",
      "value": "6",
      "name": "userradio-6"
    },
    domProps: {
      "checked": _vm.user.access === 6,
      "checked": _vm._q(_vm.user.access, "6")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.user, "access", "6")
      }
    }
  }), _vm._v(" Yes\n                                "), _c('span')]), _vm._v(" "), _c('label', {
    staticClass: "mt-radio"
  }, [_c('input', {
    staticClass: "userradio-no",
    attrs: {
      "type": "radio",
      "value": "0",
      "name": "userradio-6",
      "disabled": "disabled"
    },
    domProps: {
      "checked": _vm.user.access !== 6
    }
  }), _vm._v(" No\n                                "), _c('span')])])])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "margin-top-10"
  }, [_c('button', {
    staticClass: "btn green mt-ladda-btn ladda-button updateAccessAction_user",
    attrs: {
      "data-style": "expand-left",
      "type": "submit"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.changeAccess.apply(null, arguments)
      }
    }
  }, [_c('span', {
    staticClass: "ladda-label"
  }, [_vm._v("Save Changes")])]), _vm._v(" "), _c('button', {
    staticClass: "btn default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-hidden": "true"
    }
  }, [_vm._v(" Cancel\n                        ")])])])])])])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "caption caption-md"
  }, [_c('i', {
    staticClass: "icon-globe theme-font hide"
  }), _vm._v(" "), _c('span', {
    staticClass: "caption-subject bold uppercase"
  }, [_vm._v("Profile Account")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "active"
  }, [_c('a', {
    attrs: {
      "href": "#tab_1_1_user",
      "data-toggle": "tab",
      "aria-expanded": "true"
    }
  }, [_vm._v("My Profile")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {}, [_c('a', {
    attrs: {
      "href": "#tab_1_4_user",
      "data-toggle": "tab",
      "aria-expanded": "false"
    }
  }, [_vm._v("User Access")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "margin-top-10"
  }, [_c('button', {
    staticClass: "btn green mt-ladda-btn ladda-button changePasswordAction_user",
    attrs: {
      "data-style": "expand-left",
      "type": "submit"
    }
  }, [_c('span', {
    staticClass: "ladda-label"
  }, [_vm._v("Change Password")])]), _vm._v(" "), _c('button', {
    staticClass: "btn default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-hidden": "true"
    }
  }, [_vm._v(" Cancel\n                        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('b', [_vm._v("Referral User")]), _vm._v(" - This access allows users to submit a new referral lead to a\n                            CaseMGR Account and track submissions.\n                          ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('b', [_vm._v("Volunteer")]), _vm._v(" - This access allows users to view the Participant Dashboard, and enter and view Participant forms.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('b', [_vm._v("Case Manager")]), _vm._v(" - This access includes Volunteer privileges and allows users to add\n                            new participants and assignments, enter, edit, delete and view forms, generate reports,\n                            and modify the Participant’s Assignment page.\n                          ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('b', [_vm._v("Supervisor")]), _vm._v(" - This access includes Case Manager privileges and allows users to view a Caseload Summary for each Case Manager, view the Referral Dashboard, and create, edit, generate, and publish reports.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('b', [_vm._v("Program Administrator")]), _vm._v(" - This access includes Supervisor privileges and allows\n                            users to access Administrative Settings, manage users, import data, and create, edit,\n                            generate and publish forms.\n                          ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('b', [_vm._v("System Administrator")]), _vm._v(" - This access includes Program Administrator privileges and\n                            allows users to access all accounts and functionality.\n                          ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5bc66b44","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/UserProfile.vue
// module id = 1651
// module chunks = 1